import { TsrctDemandListItem } from '@/generated/gql/graphql';

export enum NegotiationDemandDataGridField {
  ID = 'id',
  PRIORITY = 'priority',
  SEQUENCE_NUMBER = 'sequenceNumber',
  DESCRIPTION = 'description',
  ORGANIZATION_IDS = 'organizationIds',
  COMMODITY_GROUPS = 'commodityGroups',
  TOTAL_VOLUME = 'totalVolume',
  STATE = 'state',
  REQUESTED_AT = 'requestedAt',
  DELIVERY_REQUESTED_AT = 'deliveryRequestedAt',
  DELIVERY_CONFIRMED_AT = 'deliveryConfirmedAt',
  PREFERRED_SUPPLIER_IDS = 'preferredSupplierIds',
  CAPABILITIES = 'capabilities',
  REQUESTER = 'requester',
  NUMBER_OF_CASES = 'numberOfCases',
  RESPONSIBLES = 'responsibles',
  LINKS = 'links',
  REFERENCE_ID = 'referenceId',
  PROCESSING_MODE = 'processingMode',
}

export enum NegotiationDemandDataGridColumnGroup {
  DEMAND = 'demand',
  REQUESTED = 'requested',
  DELIVERY_DATE = 'deliveryDate',
  CASES = 'cases',
}

export type NegotiationDemandDataGridRow = TsrctDemandListItem;
